var _path, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 47,
    viewBox: "0 0 34 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C7.61458 0 0 7.70252 0 17.212C0 28.0996 10.6427 41.1501 15.0875 46.1239C16.1323 47.292 17.8677 47.292 18.9125 46.1239C23.3573 41.1501 34 28.0996 34 17.212C34 7.70252 26.3854 0 17 0Z",
    fill: "#01152E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9988,
    cy: 18.9997,
    r: 6.57692,
    stroke: "white",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.92188,
    y1: 8.30737,
    x2: 24.0757,
    y2: 8.30737,
    stroke: "#B88333",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.92188,
    y1: 29.9229,
    x2: 24.0757,
    y2: 29.9229,
    stroke: "#B88333",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.77f6be38798d4fccae49d7292c6b59fe.svg";
export { ForwardRef as ReactComponent };